/** An invitation link (?invite=CODE) is remembered in this browser until the account is created. */
const KEY = "bl_invite";

export function rememberInviteFromUrl() {
  try {
    const code = new URLSearchParams(window.location.search).get("invite");
    if (code && /^[a-z0-9]{4,40}$/i.test(code)) localStorage.setItem(KEY, code.toLowerCase());
  } catch {
    /* storage unavailable */
  }
}

export function currentInvite(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function forgetInvite() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable */
  }
}
